import { useSelector } from 'react-redux';
import { maskedModeSelectors } from '../redux/modules/maskedMode';

export const useMaskedMode = (): boolean =>
  useSelector(state => {
    const maskedState = maskedModeSelectors.selectShouldMask(state);
    return maskedState;
  });

export default useMaskedMode;
